import { defineMessages } from "react-intl";

const messages = defineMessages({
  notSupportedDescription: {
    id: "settings.organizationDetails.activities.notSupportedDescription",
    defaultMessage:
      "Enabling emails lets your org send emails to accounts in MMC. We track the open and clicks on every email, seamlessly accommodate bulk sending of individual emails (mail-merge), and automatically generate email activities upon sending.",
    description: "Description of activities email not supported page",
  },
  notSupportedInterested: {
    id: "settings.organizationDetails.activities.notSupportedInterested",
    defaultMessage: "I’m Interested",
    description: "Interested action of activities email not supported page",
  },
  notSupportedInterestedDescription: {
    id: "settings.organizationDetails.activities.notSupportedInterestedDescription",
    defaultMessage: "Tap “I’m interested” and we’ll have your account manager reach out.",
    description: "Interested description of activities email not supported page",
  },
  notSupportedTitle: {
    id: "settings.organizationDetails.activities.emailFeatureTitle",
    defaultMessage: "Send and track emails in MMC",
    description: "Title of activities email not supported page",
  },
});

export default messages;
